import React from 'react';
import FocusLayout from '../../components/FocusLayout/FocusLayout';
import Login from './Login';
import { getPagePresentationKeys } from '../../actions/page';
import { SALES_CHANNELS, DEFAULT_PAGE_TITLE } from '../../constants';

const pageName = 'welcome';

async function action({ store }) {
  const {
    byName: {
      [pageName]: { pageBackgroundImage, pageTitle, pageDescription },
    },
  } = await store.dispatch(getPagePresentationKeys({ pageName }));
  return {
    chunks: ['welcome'],
    title: pageTitle || DEFAULT_PAGE_TITLE,
    description: pageDescription,
    component: (
      <FocusLayout
        gradient
        footer
        footerBar
        backgroundImage={pageBackgroundImage}
        selectCountryMessage
      >
        <Login />
      </FocusLayout>
    ),
    pageName,
    salesChannelId: SALES_CHANNELS.REDEEM,
  };
}

export default action;
